// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1_bNj","right":"styles_right__23eRN"};